import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { COLORS, TYPOGRAPHY } from '@app/constants';
import Avatar from '../Avatar';

interface Props {
  className?: string;
  imgSrc?: string;
  userName?: string;
  text?: ReactNode;
}

const User: FC<Props> = ({
  className,
  imgSrc,
  userName = '',
  text = false,
  ...props
}) => {
  return (
    <Root className={className} {...props}>
      <StyledAvatar src={imgSrc} username={userName} width={44} height={44} />
      <Info>
        <Name $isText={Boolean(text)}>{userName}</Name>
        {text && <Text>{text}</Text>}
      </Info>
    </Root>
  );
};

const Root = styled.div`
  width: 100%;
  max-width: 190px;
  display: flex;
  align-items: center;
`;

const StyledAvatar = styled(Avatar)`
  flex: 0 0 auto;
  align-self: start;
  margin-right: 16px;
`;

const Info = styled.div`
  padding-top: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
`;

const Name = styled.p<{ $isText: boolean }>`
  margin-bottom: ${({ $isText }) => $isText && '2px'};
  ${TYPOGRAPHY.body1Medium14};
  color: ${COLORS.grayscale700};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Text = styled.div`
  ${TYPOGRAPHY.disclaimerRegular12};
  color: ${COLORS.grayscale500};
`;

export default User;
